import axios from 'axios'

const API_BASE_URL = import.meta.env.VITE_API_BASE_URL || 'http://localhost:8000/api'

// Create axios instance with default config
const apiClient = axios.create({
  baseURL: API_BASE_URL,
  headers: {
    'Content-Type': 'application/json',
    'Accept': 'application/json'
  }
})

// Add request interceptor to include auth token
apiClient.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('token')
    if (token) {
      config.headers.Authorization = `Bearer ${token}`
    }
    return config
  },
  (error) => {
    return Promise.reject(error)
  }
)

export const accountsService = {
  /**
   * Get Balance Sheet Report
   */
  async getBalanceSheet(params = {}) {
    try {
      const response = await apiClient.get('/auth/accounts/reports/balance-sheet', {
        params: params
      })
      return response.data
    } catch (error) {
      console.error('Error fetching balance sheet:', error)
      throw error
    }
  },

  /**
   * Get Trial Balance Report
   */
  async getTrialBalance(params = {}) {
    try {
      const response = await apiClient.get('/auth/accounts/reports/trial-balance', {
        params: params
      })
      return response.data
    } catch (error) {
      console.error('Error fetching trial balance:', error)
      throw error
    }
  },

  /**
   * Get Income Statement Report
   */
  async getIncomeStatement(params = {}) {
    try {
      const response = await apiClient.get('/auth/accounts/reports/income-statement', {
        params: params
      })
      return response.data
    } catch (error) {
      console.error('Error fetching income statement:', error)
      throw error
    }
  },

  /**
   * Get Cash Flow Report
   */
  async getCashFlow(params = {}) {
    try {
      const response = await apiClient.get('/auth/accounts/reports/cash-flow', {
        params: params
      })
      return response.data
    } catch (error) {
      console.error('Error fetching cash flow:', error)
      throw error
    }
  },

  /**
   * Get Changes in Equity Report
   */
  async getChangesInEquity(params = {}) {
    try {
      const response = await apiClient.get('/auth/accounts/reports/changes-in-equity', {
        params: params
      })
      return response.data
    } catch (error) {
      console.error('Error fetching changes in equity:', error)
      throw error
    }
  },

  /**
   * Get Receipt and Payment Report
   */
  async getReceiptAndPayment(params = {}) {
    try {
      const response = await apiClient.get('/auth/accounts/reports/receipt-and-payment', {
        params: params
      })
      return response.data
    } catch (error) {
      console.error('Error fetching receipt and payment:', error)
      throw error
    }
  },

  /**
   * Get Day Book Report
   */
  async getDayBook(params = {}) {
    try {
      const response = await apiClient.get('/auth/accounts/reports/day-book', {
        params: params
      })
      return response.data
    } catch (error) {
      console.error('Error fetching day book:', error)
      throw error
    }
  },

  /**
   * Get Cash Book Report
   */
  async getCashBook(params = {}) {
    try {
      const response = await apiClient.get('/auth/accounts/reports/cash-book', {
        params: params
      })
      return response.data
    } catch (error) {
      console.error('Error fetching cash book:', error)
      throw error
    }
  },

  /**
   * Get Bank Book Report
   */
  async getBankBook(params = {}) {
    try {
      const response = await apiClient.get('/auth/accounts/reports/bank-book', {
        params: params
      })
      return response.data
    } catch (error) {
      console.error('Error fetching bank book:', error)
      throw error
    }
  },

  /**
   * Get General Ledger Report
   */
  async getLedger(params = {}) {
    try {
      const response = await apiClient.get('/auth/accounts/reports/ledger', {
        params: params
      })
      return response.data
    } catch (error) {
      console.error('Error fetching ledger:', error)
      throw error
    }
  },

  /**
   * Get Consignment Wise Profit/Loss Report
   */
  async getConsignmentWiseProfitLoss(params = {}) {
    try {
      const response = await apiClient.get('/auth/accounts/reports/consignment-wise-profit-loss', {
        params: params
      })
      return response.data
    } catch (error) {
      console.error('Error fetching consignment wise profit/loss:', error)
      throw error
    }
  },

  /**
   * Get Account Heads
   */
  async getAccountHeads(params = {}) {
    try {
      const response = await apiClient.get('/auth/accounts/account-heads', {
        params: params
      })
      return response.data
    } catch (error) {
      console.error('Error fetching account heads:', error)
      throw error
    }
  },

  /**
   * Get Payment Account Heads
   */
  async getPaymentAccountHeads(params = {}) {
    try {
      const response = await apiClient.get('/auth/accounts/payment-account-heads', {
        params: params
      })
      return response.data
    } catch (error) {
      console.error('Error fetching payment account heads:', error)
      throw error
    }
  },

  /**
   * Get Cost Centers
   */
  async getCostCenters(params = {}) {
    try {
      const response = await apiClient.get('/auth/accounts/cost-centers', {
        params: params
      })
      return response.data
    } catch (error) {
      console.error('Error fetching cost centers:', error)
      throw error
    }
  }
}



